/** Chữ V có mũi tên cam của logo SeriEvo (seri-evo-ecom-accounting-logo.svg), V trắng trên nền navy. */
export function BrandMark({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size * 1.25} viewBox="280 0 72 92" aria-hidden>
      <polygon points="282,30 297,30 312.02,68.32 315.49,59.45 328.5,64.55 318.52,90 305.52,90" fill="#FFFFFF" />
      <polygon
        points="318.05,52.93 331.37,18.95 324.84,16.39 345.9,1.02 350.91,26.61 344.37,24.05 331.05,58.03"
        fill="var(--brand-orange)"
      />
    </svg>
  );
}

export function Brand() {
  return (
    <div className="brand">
      <BrandMark />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
        <span>SERIEVO</span>
        <small>ECOM ACCOUNTING</small>
      </div>
    </div>
  );
}
